import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

  render: function() {
    var classes = ClassNames('lui-svg-icon', this.props.className);

    return (
      <svg
        className={classes}
        viewBox="0 0 24 24">
        {this.props.children}
      </svg>
    );
  }

});



/** WEBPACK FOOTER **
 ** ./src/components/svg-icons/svg-icon.js
 **/